export const CookieNameDelimiter: string = ':';

export function setCookieWithExpireDate(cookieName: string, cookieValue: string, exdays: number) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = 'expires=' + date.toUTCString();
  document.cookie = cookieName + '=' + cookieValue + ';' + expires + ';path=/';
}

export function setCookie(cookieName: string, cookieValue: string) {
  document.cookie = cookieName + '=' + cookieValue + ';' + ';path=/; domain=.zonarsystems.net';
}

export function getCookie(cookieName: string) {
  let name = cookieName + '=';
  let decodedCookie = decodeURIComponent(document.cookie);
  let cookieArray = decodedCookie.split(';');
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) == ' ') {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return '{}';
}
